import { restClient } from '../client';


export type SupportRequestType = {
  id: string;
  name: string;
  role: string;
  order: number;
};


export const getSupportRequestTypes = () => restClient.request<{
  data: SupportRequestType[];
}>('/api/v1/support_request_types');


type CreateSupportRequestResponse = {
  status: string;
  error: string;
};


export const createSupportRequest = (supportTypeId: string, problemText: string) =>
  restClient.request<CreateSupportRequestResponse>('/support/request/create', {
    method: 'POST',
    data: {
      support_type_id: supportTypeId,
      problem_text: problemText
    }
  });
